export const windowHeight = (): number => window.innerHeight || document.documentElement.clientHeight;
